import { gql } from '@apollo/client'

import { UserFragment } from '../../../fragments'
import { getQueryService } from '../../../../helpers/GraphqlHelpers'
import { MeQuery, User } from '../../../generated/graphql'

export const me = getQueryService({
  query: gql`
    query me {
      me {
        ...UserFragment
      }
    }
    ${UserFragment}
  `,
  transformer: (response: MeQuery) => {
    return response.me as User
  },
})
